import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Punchout } from "@/lib/punchout";

interface TopbarProps {
  punchout: Punchout;
}

export function Topbar({ punchout }: TopbarProps) {
  const me = useQuery({ queryKey: ["me"], queryFn: api.me });
  const personLabel =
    punchout.user_name || punchout.user_email || me.data?.email || "";

  return (
    <header className="border-b border-border bg-card/60 backdrop-blur">
      <div className="container mx-auto flex items-center justify-between gap-4 py-4">
        <Link to="/" className="flex items-center gap-3 text-foreground no-underline">
          <img src="/static/max.png" alt="Property Meld" className="h-7 w-auto" />
          <div className="leading-tight">
            <div className="font-display text-base font-semibold tracking-tight">
              TrueCost <span className="text-primary">·</span> Billing survey
            </div>
            <div className="text-xs text-muted-foreground">
              Help us understand how you bill today
            </div>
          </div>
        </Link>
        <div className="hidden text-right text-xs leading-tight sm:block">
          {punchout.company && (
            <div className="font-medium text-foreground">{punchout.company}</div>
          )}
          {personLabel && (
            <div className="text-muted-foreground">{personLabel}</div>
          )}
          {me.data?.is_admin && (
            <Link to="/admin" className="text-primary hover:underline">
              Admin
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
